import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from "chart.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

function DashboardLineChart({ lineChartData }) {
    // console.log("Line Chart Data:", lineChartData);
    
    const data = {
        labels: lineChartData.labels,
        datasets: [
            {
                data: lineChartData.data,
                borderColor: "#491ACB",
                borderWidth: 1,
                pointRadius: 10,
                tension: 0, // curve
            },
        ],
    };

    const options = {
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            title: { display: false, text: "Monthly Sales" },
        },
        scales: {
            x: {
                ticks: {
                    color: "#B6B6B6",  // X-axis label color
                    font: {
                        size: 14,      // X-axis font size
                        // weight: 'bold'
                    }
                }
            },
            y: {
                ticks: {
                    color: "#B6B6B6", // Y-axis label color
                    font: {
                        size: 14,     // Y-axis font size
                        // weight: 'bold'
                    }
                }
            }
        }
    };

    return (
        <div style={{width: '100%', height: '300px'}}>
            <Line data={data} options={options} />
        </div>
    )
}

export default DashboardLineChart
